<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="row">
          <div class="col-12">
            <span class="font-weight-bolder font-size-lg">{{$t('QUOTATION.Offer')}}</span>
            <div class="row pt-3">
              <div class="col">
                {{$t('QUOTATION.Material_classification')}}
                <select class="form-control form-control-sm" v-model="quotation.materialTypeId" v-on:change="loadQuotationArrange">
                  <option v-for="item in materialTypeList" :key="item.recordId" :value="item.recordId">
                    {{activeLanguage === 'en'? item.eNames : item.materialName}}
                  </option>
                </select>
              </div>
              <div class="col">
                {{$t('QUOTATION.Process_classification')}}
                <select class="form-control form-control-sm" v-model="quotation.craftTypeId" v-on:change="loadQuotationArrange">
                  <option v-for="item in craftTypeList" :key="item.recordId" :value="item.recordId">
                    {{activeLanguage === 'en'? item.eNames : item.craftName}}
                  </option>
                </select>
              </div>
              <div class="col-xl-12 pt-0 pb-0">
                <span class="text-muted">{{$t('QUOTATION.Click_on_the_blue_price_below_to_modify_it')}}</span>
              </div>
            </div>
            <div class="row p-3">
              <div class="col-xl-12 border-bottom">
                <div class="row border-left border-top  border-right">
                  <template v-for="(item, index) in quotationArrangeList">
                    <div :class="index%2===0? 'col bg-light-primary pt-1 pb-1 pl-0 pr-0 text-center':'col bg-light-warning pt-1 pb-1 text-center'" :key="item.recordId">
                      <span class="font-weight-bolder font-size-sm">{{item.arrange}}㎡</span>
                    </div>
                  </template>
                </div>
                <template v-for="item in interCraftList">
                  <div class="row" :key="item.recordId">
                    <div class="col-xl-12">
                      <div class="row border">
                        <div class="col-xl-12 pt-1 pb-1 font-weight-bolder font-size-base">
                          {{activeLanguage === 'en'? item.eNames : item.interCraftName}}
                        </div>
                      </div>
                      <div class="row border">
                        <template v-for="(row, sortIndex) in item.interCraftDetailList">
                          <div :class="sortIndex%2===0? 'col bg-light-primary pt-1 pb-1':'col bg-light-warning pt-1 pb-1'" :key="row.recordId">
                            <span class="text-primary font-size-lg font-weight-bolder" v-on:click="openQuotation(row,item)">{{ isNaN(row.price) ? 0 : row.price}}</span>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <b-modal ref="openQuotation" hide-footer hide-header hide-header-close size="small">
      <div class="row">
        <div class="col-xl-12 text-muted pt-1 pb-1">
          <h3>{{$t('QUOTATION.Process_information')}}</h3>
        </div>
        <div class="col-xl-12 font-weight-bolder pt-1 pb-1">
          <span>{{interCraftName}}</span>
        </div>
      </div>
      <div class="row pt-3 pb-3">
        <div class="col-xl-12 text-muted pt-1 pb-1">
          <h3>{{$t('ORDER.Price')}}</h3>
        </div>
        <div class="col-6 pt-1 pb-1">
          <input type="text" class="form-control" v-model="quotation.price"
                 oninput="this.value = this.value.replace(/^0*(\d+(\.\d*)?)$|^(\.(\d*))?$|^[^\d.].*$|(\d+\.\d*\.|\d*\.0*)/g, '$1').replace(/[^\d.]/g, '');"/>
        </div>
      </div>
      <div class="row border-top">
        <div class="col-xl-12 text-right">
          <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" @click="close">{{$t('ONLINE.Cancel')}}</button>&nbsp;
          <button type="button" class="btn btn-sm btn-primary" v-on:click="updateQuotationPrice">{{$t('ACCOUNT.Save_Changes')}}</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service";
export const SETAUTH = "setauth";
export default {
  mounted() {
    this.loadDate();
  },
  computed: {
    user: {
      get () {return this.$store.getters.currentUser;}
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  data(){
    return{
      materialTypeList:[],
      craftTypeList:[],
      quotationArrangeList:[],
      interCraftList:[],
      quotation:{
        price:"",
        materialTypeId:"",
        craftTypeId:"",
      },
      processPriceId:"",
      interCraftName:"",

    }
  },
  methods:{
    //换算汇率
    loadDate(){
      const _this = this;
      this.$axios.fetchPost("is/offer/getQuotationSelectDate", {}).then(result => {
        _this.materialTypeList = result.data.materialTypeList;
        _this.craftTypeList = result.data.craftTypeList;
        if (_this.materialTypeList && _this.materialTypeList.length > 0)
        {
          this.quotation.materialTypeId = _this.materialTypeList[0].recordId;
        }
        if (_this.craftTypeList && _this.craftTypeList.length > 0)
        {
          this.quotation.craftTypeId = _this.craftTypeList[0].recordId;
        }
        _this.loadQuotationArrange();
        _this.getInterCraftList();
      }).catch(err => {alert(err)});
    },
    loadQuotationArrange(){
      const query = {};
      query.craftId = this.quotation.craftTypeId;
      const _this = this;
      this.$axios.fetchPost("is/offer/getLoadQuotationArrange", query).then(result => {
        _this.quotationArrangeList = result.data;
        _this.getInterCraftList();
      }).catch(err => {alert(err)});
    },

    getInterCraftList()
    {
      const query = {};
      query.materialTypeId = this.quotation.materialTypeId;
      query.craftIdTypeId = this.quotation.craftTypeId;
      query.number = "1";
      query.userId = this.user.recordId;
      const _this = this;
      this.$axios.fetchPost("is/offer/getInterCraftList", query).then(result => {
        _this.interCraftList = result.data;
      }).catch(err => {alert(err)});
    },
    openQuotation(row,item){
      this.quotation.price = "";
      this.processPriceId = row.recordId;
      this.quotation.price = row.price;
      this.interCraftName =  this.activeLanguage === 'en'? item.eNames : item.interCraftName;
      this.quotation.recordId = row.processCustomerId;
      this.$refs['openQuotation'].show();
    },
    updateQuotationPrice()
    {
      const query = {};
      query.processQuotationId = this.processPriceId;
      query.price = this.quotation.price;
      query.quoteCustomerId = this.user.recordId;
      query.recordId = this.quotation.recordId;
      const _this = this;
      this.$axios.fetchPost("is/offer/updateQuotationPrice", query).then(result => {
        if (result.data === "success")
        {
          alert(this.$t('QUOTATION.Bid_successful'));
          _this.getInterCraftList();
          _this.$refs['openQuotation'].hide();
        }
      }).catch(err => {alert(err)});
    },
    close(){
      this.$refs['openQuotation'].hide();
    },
  }
}
</script>